import {PlaceOfServiceService} from 'services/placeOfServiceService';
import {createEntityThunks} from 'utils/createEntityThunks';
import {PlaceOfService} from 'types/placeOfService';

export const PlaceOfServicesThunks = createEntityThunks<PlaceOfService>(
  'placeOfService',
  PlaceOfServiceService,
  {activate: true, deactivate: true},
);
